<template>
    <section
        class="relative mx-auto flex h-full w-full items-center justify-center bg-blue md:h-auto md:min-h-full"
        ref="rootEl"
    >
        <div
            class="flex h-full flex-col items-center justify-center gap-2 lg:gap-6"
            ref="rootEl"
        >
            <div
                class="mx-auto max-w-2xl space-y-6 px-4 text-center opacity-0"
                ref="contentEl"
            >
                <h2
                    class="text-balance px-6 font-aktivCondensed text-4xl font-extrabold text-white md:px-0 lg:text-5xl xl:text-6xl"
                    tabindex="-1"
                    ref="headlineEl"
                    v-html="slide.headline"
                ></h2>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, onBeforeUnmount } from "vue";
import type { QuestionIntroSlide } from "../types";
import { useRouter } from "vue-router";
import { useQuizStore } from "../stores/quizStore";

import gsap from "gsap";
import SplitText from "gsap/SplitText";
import { animateWord } from "../animations/questionIntroMicroAnim";

gsap.registerPlugin(SplitText);

const props = defineProps<{ slide: QuestionIntroSlide }>();
const router = useRouter();
const quiz = useQuizStore();

const rootEl = ref<HTMLElement | null>(null);
const contentEl = ref<HTMLElement | null>(null);
const headlineEl = ref<HTMLElement | null>(null);

const autoAdvanceDelay = 0.75;
const wordDuration = 0.4;
const wordStagger = 0.07;
const tl = gsap.timeline();

onMounted(async () => {
    await nextTick();

    tl.set(contentEl.value, { opacity: 1 });

    const split = new SplitText(headlineEl.value as HTMLElement, {
        type: "words",
    });

    tl.from(split.words, {
        opacity: 0,
        y: 30,
        duration: wordDuration,
        stagger: wordStagger,
        ease: "power3.out",
    });

    const animSpans = headlineEl.value?.querySelectorAll("[data-anim]");
    if (animSpans) {
        animSpans.forEach((el: Element) => {
            const type = (el as HTMLElement).dataset.anim;
            if (type) animateWord(el as HTMLElement, type as any, tl);
        });
    }

    // tl.to({}, { duration: autoAdvanceDelay });

    tl.to(
        split.words,
        {
            opacity: 0,
            y: -20,
            duration: wordDuration,
            stagger: wordStagger,
            ease: "power2.in",
        },
        `+=${autoAdvanceDelay}`,
    );

    tl.call(() => goNext());
});

function goNext() {
    const idx = quiz.slides.findIndex((s) => s.id === props.slide.id);
    const next = quiz.slides[idx + 1];
    if (next) router.replace(next.route);
}
onBeforeUnmount(() => {
    tl.kill();
});
</script>
<style>
[data-anim] {
    display: inline-block;
}
</style>
